<template>
	<li
		class="grid-noGutter attachmentlist__item"
		:class="{ 'attachmentlist__item--visible': isExpanded }"
		:id="data.attachmentTitle"
	>
		<div class="col-12_smx-8">
			<div class="grid attachmentlist__item-text">
				<button
					class="attachmenlist__item-icon button--nostyling"
					@click="toggle"
					v-html="IconChevron"
					:aria-expanded="isExpanded ? 'true' : 'false'"
				></button>
				<div class="col-12_smx-4 attachmentlist__item-column">
					<div class="attachmentlist__item-date">
						{{ formattedDate }}
					</div>
				</div>
				<div class="col-12_smx-8 attachmentlist__item-column">
					<div class="attachmentlist__item-title">
						{{ data.attachmentTitle }}
					</div>
				</div>
			</div>
		</div>
		<div class="col-12_smx-4">
			<div class="grid">
				<div class="col-12_smx-12 attachmentlist__item-column">
					<ul
						aria-hidden="false"
						class="ul--nostyling attachmentlist__item-files"
					>
						<li
							v-if="data.agendaFile"
							class="attachmentlist__item-file"
						>
							<a
								class=" link--download"
								:href="data.agendaFile.url"
								target="blank"
							>
								{{ translations.translationAgenda }} ({{
									data.agendaFile.fileSize
								}}
								MB)
							</a>
						</li>
						<li
							v-if="data.agendaWithAppendixFile"
							class="attachmentlist__item-file"
						>
							<a
								class=" link--download"
								:href="data.agendaWithAppendixFile.url"
								target="blank"
							>
								{{ translations.translationAgendaWithAppendix }}
								({{ data.agendaWithAppendixFile.fileSize }}
								MB)
							</a>
						</li>
						<li
							v-if="data.summaryFile"
							class="attachmentlist__item-file"
						>
							<a
								class="link--download"
								:href=data.summaryFile.url
								target="blank"
							>
								{{ translations.translationSummary }} ({{
									data.summaryFile.fileSize
								}}
								MB)
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</li>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import IconChevron from "../../../../views/icons/chevron.cshtml";

const props = defineProps(['data', 'translations']);
const isExpanded = ref(false);

const formattedDate = computed(() => {
	return utilities.formatDate(props.data.attachmentDate);
});

const checkHash = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const listItemId = urlParams.get("listItemId");
	if (listItemId) {
		if (listItemId == props.data.attachmentTitle) {
			document.getElementById(props.data.attachmentTitle).scrollIntoView();
			show();
		}
	}
};

const toggle = () => {
	isExpanded.value = !isExpanded.value;
	if (isExpanded.value) {
		utilities.setQueryStringParameter("listItemId", props.data.attachmentTitle);
	} else {
		utilities.deleteQueryStringParameter("listItemId");
	}
};

const show = () => {
	isExpanded.value = true;
};

const hide = () => {
	isExpanded.value = false;
};

onMounted(() => {
	checkHash();
});
</script>
